import { usePermissionsStore } from '@/stores/permissions';
// import { computed } from 'vue';


export function usePermissions() {

  const permissionStore = usePermissionsStore();

  const hasPermission = (permission) => permissionStore.hasPermission(permission).value;
  const hasAnyPermission = (permissions) => permissionStore.hasAnyPermission(permissions).value;
  const hasAllPermissions = (permissions) => permissionStore.hasAllPermissions(permissions).value;

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    updatePermissions: permissionStore.updatePermissions,
  };
} 